// extracted by mini-css-extract-plugin
export default {"form_ct":"ClassRegi_form_ct__Kzhtv","ho_p":"ClassRegi_ho_p__y3TxH"};